module.exports = __webpack_public_path__ + "static/media/location-icon.18b2fd1b.svg";